<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="localLoading || loading"
      disable-pagination
      disable-filtering
      disable-sort
      hide-default-footer
      hide-default-header
      dense
      class="my-2"
    >
      <template v-slot:item="{ item }">
        <tr @click="redirectBed(item.bedId)">
          <td>
            <p class="caption">{{ item.bed }}</p>
          </td>
          <td class="nowrap">
            <p class="caption">{{ item.moveOut }}</p>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Hashids from 'hashids'
const hashids = new Hashids()

export default {
  props: ['items', 'loading'],
  data() {
    return {
      headers: [
        { text: 'Bed', value: 'bed' },
        { text: 'Move Out Date', value: 'moveOut' }
      ],
      bedsListOccupied: [],
      localLoading: this.loading
    }
  },
  methods: {
    redirectBed(bedId) {
      if (!this.localLoading) {
        this.localLoading = true
        this.$router.push('bed/' + hashids.encode(bedId))
      }
    }
  }
}
</script>

<style scoped>
table tbody tr td {
  border: none !important;
  border-bottom: none !important;
}
p {
  margin-bottom: 0;
}
.v-data-table {
  background-color: #ffffff;
}

.nowrap {
  white-space: nowrap;
}
</style>
